<style scoped lang='scss'>
.card-item {
  margin-bottom: 16px;
}
</style>

<template>
  <div>
    <mu-row gutter>
      <mu-col span="12" sm="12" md="12" lg="8" xl="8">
        <ViewCard :channel="channel" class="card-item"/>
      </mu-col>
      <mu-col span="12" sm="12" md="12" lg="4" xl="4">
        <NowCard :channel="channel" class="card-item"/>
      </mu-col>
      <mu-col span="12">
        <PopularCard :channel="channel" class="card-item"/>
      </mu-col>
    </mu-row>
  </div>
</template>

<script>
// Components
import ViewCard from "@/components/Analytics/View/Main.vue";
import NowCard from "@/components/Analytics/Now/Main.vue";
import PopularCard from "@/components/Analytics/Popular/Main.vue";

// Library
import axios from "axios";

export default {
  name: "AnalyticsHome",
  props: {
    channel: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    
  }),
  computed: {

  },
  components: {
    ViewCard,
    NowCard,
    PopularCard,
  },
  created() {
    
  },
  watch: {
    
  },
  methods: {
    
  },
};
</script>
